import { render, staticRenderFns } from "./PublishmentComplete.vue?vue&type=template&id=489ca963&"
import script from "./PublishmentComplete.vue?vue&type=script&lang=ts&"
export * from "./PublishmentComplete.vue?vue&type=script&lang=ts&"
import style0 from "./PublishmentComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports